export default {
    title_list: 'Posts',
    title_page: 'Post page',
    title_create_page: 'Create post page',
    title_edit_page: 'Change post page',

    labels: {
        drag_in_drop: 'Drag or click to select files',
    },

    filter: {
        labels: {
            categories: 'Category',
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            categories: 'Category',
            slug: 'Slug',
            title: 'Title',
        }
    },

    buttons: {

    },

    form: {
        categories: 'Category',
        slug: 'Slug',
        author: 'Author',
        title: 'Title',
        description: 'Description',
        seo_title: 'SEO Title',
        seo_description: 'SEO Description (also used for Notification text)',
        seo_keywords: 'SEO Keywords',
        visible: 'Visible',
        image: 'Image preview',
        published_at: 'When posted',
        is_press: 'For Press Center',
    },
}
